/*
 * @Author: Chao Yang
 * @Date: 2020-12-15 09:40:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 02:52:29
 */
import { Injectable } from '@angular/core';
import { ConfigurationProxy } from '../../proxy';
import { IConfiguration } from '../../model/configuration';
import { IDateRange } from '../../model/dashboard';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdDateRangeModel } from 'basic-component';
import { DateRangeTypeEnum } from 'src/app/common/model/dateRangeType.enum';
import {
  addDays,
  addQuarters,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
} from 'date-fns';
import { CommonService } from '../common/common.service';
import { SessionService } from '../session';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class ConfigurationService {
  /**
   *
   */
  constructor(
    private dashboardConfigurationProxy: ConfigurationProxy,
    private commonService: CommonService,
    private sessionService: SessionService
  ) {}

  GetDateRange(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<IConfiguration<IDateRange>> {
    return this.dashboardConfigurationProxy.GetDateRange(accounts).pipe(
      map((response) => {
        response.value.type = response.value.type as number;
        return response;
      })
    );
  }

  UpdateDateRange(config: IConfiguration<IDateRange>) {
    if (this.sessionService.isShadow()) {
      return this.dashboardConfigurationProxy.getShadowUserDefaultObservable();
    }
    return this.dashboardConfigurationProxy.UpdateDateRange(config);
  }

  getNowWithoutHMS(): Date {
    return this.commonService.getNowWithoutHMS();
  }

  GenerateDateRangeUseConfig(data: IDateRange): AdDateRangeModel {
    switch (data.type) {
      case DateRangeTypeEnum.ytd:
        return {
          startDate: new Date(this.getNowWithoutHMS().getFullYear(), 0, 1),
          endDate: this.getNowWithoutHMS(),
        };
      case DateRangeTypeEnum.q1:
        return {
          startDate: addQuarters(this.getNowWithoutHMS(), -1),
          endDate: this.getNowWithoutHMS(),
        };
      case DateRangeTypeEnum.q2:
        return {
          startDate: addQuarters(this.getNowWithoutHMS(), -2),
          endDate: this.getNowWithoutHMS(),
        };
      case DateRangeTypeEnum.q3:
        return {
          startDate: addQuarters(this.getNowWithoutHMS(), -3),
          endDate: this.getNowWithoutHMS(),
        };
      case DateRangeTypeEnum.q4:
        return {
          startDate: addQuarters(this.getNowWithoutHMS(), -4),
          endDate: this.getNowWithoutHMS(),
        };
      case DateRangeTypeEnum.custom:
        return {
          startDate: data.start ? new Date(data.start) : null,
          endDate: data.end ? new Date(data.end) : null,
        };
      case DateRangeTypeEnum.itd:
      default:
        return {
          startDate: undefined,
          endDate: this.getNowWithoutHMS(),
        };
    }
  }
}
